import { canPersistLock, hasLogoutCookie, writeLogoutCookie } from "./lockPersistence";

export const ACCOUNT_LOCK_KEY = "oransim_account_lock";
export const ACCOUNT_EVENT_KEY = "oransim_account_event";
let memoryLock: boolean | null = null;
let localOnlyLock = false;
export function hasAccountLock(): boolean {
  if (memoryLock === true) return true;
  let unreadable = false;
  for (const name of ["localStorage", "sessionStorage"] as const) {
    try { if (window[name].getItem(ACCOUNT_LOCK_KEY) !== null) return true; }
    catch { unreadable = true; }
  }
  try { if (hasLogoutCookie()) return true; } catch { unreadable = true; }
  const unconfirmed = (unreadable && memoryLock !== false) || (memoryLock === null && !canPersistLock());
  if (unconfirmed) { memoryLock = true; localOnlyLock = true; }
  return unconfirmed;
}
/** 内存锁同步生效；返回本次持久写入/删除的回读确认结果。 */
export function setAccountLock(locked: boolean): boolean {
  memoryLock = locked;
  const write = (storageName: "localStorage" | "sessionStorage", value: string | null) => {
    try {
      const storage = window[storageName];
      if (value !== null) storage.setItem(ACCOUNT_LOCK_KEY, value); else storage.removeItem(ACCOUNT_LOCK_KEY);
      return storage.getItem(ACCOUNT_LOCK_KEY) === value;
    } catch { return false; }
  };
  const local = write("localStorage", locked ? "locked" : null);
  const cookie = writeLogoutCookie(locked);
  localOnlyLock = locked && !local && !cookie;
  const session = write("sessionStorage", locked ? localOnlyLock ? "local-only" : "locked" : null);
  return locked ? local || cookie || session : local && cookie && session;
}
/** 共享锁移除只允许重新确认服务端身份，不携带或直接接受其他标签身份。 */
export function reconcileSharedUnlock(): void {
  try {
    if (localOnlyLock || sessionStorage.getItem(ACCOUNT_LOCK_KEY) === "local-only") return;
    if (!hasLogoutCookie() && localStorage.getItem(ACCOUNT_LOCK_KEY) === null) {
      sessionStorage.removeItem(ACCOUNT_LOCK_KEY);
      if (sessionStorage.getItem(ACCOUNT_LOCK_KEY) === null) memoryLock = false;
    }
  } catch { /* 无法读取共享锁时维持本标签关闭。 */ }
}
